import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'stat-card',
  templateUrl: 'stat-card.component.html',
  styleUrls: ['stat-card.component.scss']
})
export class StatCardComponent {
  @Input() icon: string;
  @Input() label: string;
  @Input() sublabel: string;

}
